
import { Component, Vue, Ref } from 'vue-property-decorator'
import { UserService } from '@/services'
import { UserModule } from '@/store/modules/user'
import PhoneTable, { ChangeOption } from './components/phoneTable.vue'
import ScrollTo from '@/components/scroll_to/index.vue'
import ScrollToType from '@/components/scroll_to/type'

enum STATUS {
    All = 0,
    Ing = 1,
    Pass = 2,
    Fail = 3
}

@Component({
    name: 'ViewPhone',
    components: {
        PhoneTable,
        ScrollTo
    }
})
export default class extends Vue {
    @Ref('scrollRef') private scrollEl!: ScrollToType
    private pageSize = 15
    private pageIndex = 1
    private pageTotal = 0
    private isLoading = true
    private status = STATUS.All
    private statusList = [
        { label: '全部', value: STATUS.All },
        { label: '审核中', value: STATUS.Ing },
        { label: '审核通过', value: STATUS.Pass },
        { label: '审核不通过', value: STATUS.Fail }
    ]
    private applyList = []

    get userId() {
        return UserModule.userId
    }

    private mounted() {
        this.getApplyList()
    }

    private async getApplyList() {
        const params = {
            status: this.status,
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        this.isLoading = true
        const result = await UserService.getPhoneApplyList(params)
        this.isLoading = false
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.applyList = result.data.list
        }
    }

    private onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.scrollEl.scrollToTop(this.getApplyList)
    }

    private async onStatusChange({ status, target }: ChangeOption) {
        const params = { status, id: target.id }
        const result = await UserService.updatePhoneApply(params)
        if (result.status === 200) {
            target.status = status
            this.$message({
                type: 'success',
                message: '状态修改成功',
                showClose: true
            })
            return
        }
        this.$message({
            type: 'error',
            message: result.message || '状态修改失败',
            showClose: true
        })
    }

    private onStatusSelect(status: number) {
        this.status = status
        this.getApplyList()
    }
}
